import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  setUserProfile,
  GET_USER_PROFILE_MESSAGE_TYPE,
  type UserProfileAggregate,
} from '@leagueplatform/user-profile-api';

const CAREGIVER_ONBOARDING_COMPLETE_FIELD = 'caregiver_onboarding_complete';

export const useSetCaregiverOnboardingComplete = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const profile = queryClient.getQueryData<UserProfileAggregate>([
        GET_USER_PROFILE_MESSAGE_TYPE,
      ]);
      const existingFields = profile?.custom_fields ?? [];
      const updatedFields = [
        ...existingFields.filter(
          (f) => f.name !== CAREGIVER_ONBOARDING_COMPLETE_FIELD,
        ),
        { name: CAREGIVER_ONBOARDING_COMPLETE_FIELD, value: 'true' },
      ];
      // custom_fields is accepted by the server but not in the SDK's UserProfile type
      await setUserProfile({ custom_fields: updatedFields } as never);
    },
    onSuccess: () => {
      queryClient.invalidateQueries();
    },
  });
};
